import moment from 'moment';

export const prepareReqBody = (
  filters: any,
  offset: number,
  limit: number,
  isQuote = false,
  sort = [
    {
      field: 'effectiveDate',
      direction: 'desc'
    }
  ]
) => {
  const requestBody: any = {
    searchStr: filters.searchStr,
    limit,
    offset,
    ...(sort && { sort })
  };

  if (
    filters.accountId ||
    filters.date ||
    filters.status ||
    filters.locationId ||
    filters.salesRep ||
    filters.territory ||
    filters.accountName ||
    filters.type
  ) {
    requestBody.filters = {
      $and: []
    };

    if (filters.type) {
      requestBody.filters.$and.push({
        field: 'type',
        operator: '$eq',
        value: filters.type
      });
    }

    if (filters.accountId) {
      requestBody.filters.$and.push({
        field: 'account._id',
        operator: '$eq',
        value: filters.accountId
      });
    }

    if (filters.locationId) {
      requestBody.filters.$and.push({
        field: 'address.locationId',
        operator: '$eq',
        value: filters.locationId
      });
    }

    if (filters.date) {
      requestBody.filters.$and.push({
        // Screens that key off another date pass it in - invoices use invoiceDate.
        field: isQuote ? 'createdAt' : filters.dateField || 'effectiveDate',
        operator: '$between',
        value: [
          moment
            .utc(filters.date[0], 'YYYY-MM-DD')
            .startOf('day')
            .toISOString(),
          moment.utc(filters.date[1], 'YYYY-MM-DD').endOf('day').toISOString()
        ]
      });
    }

    if (filters.status) {
      requestBody.filters.$and.push({
        field: 'status',
        operator: '$eq',
        value: filters.status
      });
    }

    if (filters.salesRep) {
      const salesRepConditions: {
        field: string;
        operator: string;
        value: string;
      }[] = [];

      filters.salesRep.forEach((salesRep: any) => {
        salesRepConditions.push(
          {
            field: 'salesRepId',
            operator: '$eq',
            value: salesRep
          },
          {
            field: 'account.salesRepIds',
            operator: '$eq',
            value: salesRep
          },
          {
            field: 'address.salesRepIds',
            operator: '$eq',
            value: salesRep
          }
        );
      });

      requestBody.filters.$and.push({
        $or: salesRepConditions
      });
    }

    if (filters.territory) {
      requestBody.filters.$and.push({
        field: 'account.territory',
        operator: '$eq',
        value: filters.territory
      });
    }

    if (filters.accountName && !filters.accountId) {
      requestBody.filters.$and.push({
        field: 'account.name',
        operator: '$eq',
        value: filters.accountName
      });
    }

    if (filters.statusId) {
      requestBody.filters.$and.push({
        field: 'statusId',
        operator: '$eq',
        value: filters.statusId
      });
    }
  }

  return requestBody;
};
